/** The migration wizard for one path; the empty path is the unfiled documents. */
export function migrateHref(orgId: string, path: string): string {
  return `/orgs/${orgId}/collections/migrate?${new URLSearchParams({ path }).toString()}`;
}
